import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from './components/error-message';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchSortFilterComponent } from './components/search-sort-filter';
import { TabsComponent } from './components/tabs';
import {
	EntryItemPipe,
	EnumToArrayPipe,
	HeaderTitlePopoverPipe,
	HeaderTitleVerticalLinePipe,
	TruncateTextPipe
} from './components/pipes';
import { ToastService } from './toast';
import { AlertBoxService, FilePicker } from './plugins';
import { DebounceKeyupDirective, ThrottleButtonDirective } from './directives';
import { ExpandableCardComponent, HorizontalMenuComponent, SlidingCardComponent } from './components';
import { AlertService } from './alert/services/alert.service';
import { DateTimeService } from './services/date-time.service';
import {
	AppInformationService,
	ClipboardService,
	DeviceActionsService,
	EncryptionService,
	FormattingService,
	GuidGeneratorService,
	ModalService,
	PlatformProvider,
	ScreenOrientationService,
	StorageService
} from './services';
import { IonicModule } from '@ionic/angular';
import { SampleCardComponent } from './components/sample-card';
import { ItemPickerComponent } from './components/item-picker/item-picker.component';
import { OtpInputComponent } from './components';
import { NgOtpInputModule } from 'ng-otp-input';
import { IonicStorageModule } from '@ionic/storage-angular';
import { LoadingIndicatorComponent } from './loading-indicator';

@NgModule({
	declarations: [
		ErrorMessageComponent,
		SearchSortFilterComponent,
		TabsComponent,
		EntryItemPipe,
		TruncateTextPipe,
		EnumToArrayPipe,
		HeaderTitlePopoverPipe,
		HeaderTitleVerticalLinePipe,
		LoadingIndicatorComponent,
		DebounceKeyupDirective,
		ThrottleButtonDirective,
		ExpandableCardComponent,
		SampleCardComponent,
		ItemPickerComponent,
		OtpInputComponent,
		SlidingCardComponent,
		HorizontalMenuComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		FormsModule,
		IonicModule,
		NgOtpInputModule,
		IonicStorageModule.forRoot()
	],
	providers: [
		ToastService,
		FilePicker,
		AlertBoxService,
		AlertService,
		DateTimeService,
		PlatformProvider,
		StorageService,
		ModalService,
		DeviceActionsService,
		AppInformationService,
		ScreenOrientationService,
		ClipboardService,
		GuidGeneratorService,
		FormattingService,
		EncryptionService,
	],
	exports: [
		ErrorMessageComponent,
		SearchSortFilterComponent,
		TabsComponent,
		EntryItemPipe,
		TruncateTextPipe,
		EnumToArrayPipe,
		HeaderTitlePopoverPipe,
		HeaderTitleVerticalLinePipe,
		TranslateModule,
		DebounceKeyupDirective,
		ThrottleButtonDirective,
		LoadingIndicatorComponent,
		ExpandableCardComponent,
		SampleCardComponent,
		ItemPickerComponent,
		OtpInputComponent,
		HorizontalMenuComponent,
		SlidingCardComponent
	]
})
export class SharedModule {}
